import React from "react";
import { Trash2, Download, Archive } from "lucide-react";
import { fmtPrice } from "../../../../lib/format";

export const StatCards = ({ stats }) => {
  const cards = [
    ["Revenue (paid)", `AED ${Number(stats.revenue || 0).toLocaleString()}`],
    ["Total Orders", stats.total_orders],
    ["Paid Orders", stats.paid_orders],
    ["Products", stats.products],
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="dashboard-cards">
      {cards.map(([l, v]) => (
        <div key={l} className="border border-[#262421] p-6">
          <p className="text-[10px] uppercase tracking-widest text-[#8A857D]">{l}</p>
          <p className="serif text-3xl text-[#C49A6C] mt-3">{v ?? 0}</p>
        </div>
      ))}
    </div>
  );
};

export const PerPerfumeTable = ({ rows }) => (
  <>
    <h2 className="serif text-xl mt-12 mb-4">المبيعات لكل عطر · الفترة الحالية</h2>
    <div className="border border-[#262421]" data-testid="per-perfume-table">
      <div className="grid grid-cols-3 px-5 py-3 text-[10px] uppercase tracking-widest text-[#8A857D] border-b border-[#262421]">
        <span>العطر</span><span className="text-center">القطع المباعة</span><span className="text-end">الإيرادات</span>
      </div>
      {rows?.length ? rows.map((p) => (
        <div key={p.product_id || p.name} className="grid grid-cols-3 px-5 py-4 border-b border-[#262421] last:border-b-0" data-testid={`perfume-row-${p.product_id}`}>
          <span className="text-[#F2EBE1] text-sm">{p.name}</span>
          <span className="text-center text-[#C49A6C] serif text-lg">{p.units}</span>
          <span className="text-end text-[#C49A6C] serif text-lg">{fmtPrice(p.revenue, "AED")}</span>
        </div>
      )) : <div className="px-5 py-8 text-center text-[#8A857D] text-sm">لا توجد مبيعات في الفترة الحالية بعد</div>}
    </div>
  </>
);

const ArchiveCard = ({ a, onCsv, onDelete }) => (
  <div className="border border-[#262421]" data-testid={`archive-${a.id}`}>
    <div className="flex items-center justify-between px-5 py-4 border-b border-[#262421] gap-3 flex-wrap">
      <div>
        <p className="text-[#F2EBE1] text-sm">{a.label}</p>
        <p className="text-[10px] uppercase tracking-widest text-[#8A857D] mt-1">
          {a.period_start ? `${String(a.period_start).slice(0, 10)} ← ` : "البداية ← "}{String(a.period_end).slice(0, 10)}
          {" · "}{a.paid_orders} طلب مدفوع · {fmtPrice(a.revenue, "AED")}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={() => onCsv(a.id)} data-testid={`archive-csv-${a.id}`} className="flex items-center gap-1.5 border border-[#262421] text-[#C49A6C] text-[11px] uppercase tracking-[0.15em] px-3 py-2 hover:border-[#C49A6C] transition-colors"><Download size={13} /> CSV</button>
        <button onClick={() => onDelete(a.id)} data-testid={`archive-del-${a.id}`} className="text-[#8A857D] hover:text-[#c88] p-2"><Trash2 size={15} /></button>
      </div>
    </div>
    {a.per_product?.length > 0 && (
      <div className="divide-y divide-[#262421]">
        {a.per_product.map((p) => (
          <div key={p.product_id || p.name} className="grid grid-cols-3 px-5 py-2.5 text-sm">
            <span className="text-[#C9C0B4]">{p.name}</span>
            <span className="text-center text-[#8A857D]">{p.units} قطعة</span>
            <span className="text-end text-[#8A857D]">{fmtPrice(p.revenue, "AED")}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

export const ArchiveList = ({ archives, onCsv, onDelete }) => (
  <>
    <h2 className="serif text-xl mt-12 mb-4 flex items-center gap-2"><Archive size={18} /> الأرشيف (اللقطات المحفوظة)</h2>
    <div className="space-y-4" data-testid="stats-archives">
      {archives.length === 0
        ? <div className="border border-[#262421] px-5 py-8 text-center text-[#8A857D] text-sm">لا يوجد أرشيف بعد. اضغط "حفظ وتصفير الأرقام" لحفظ أول لقطة.</div>
        : archives.map((a) => <ArchiveCard key={a.id} a={a} onCsv={onCsv} onDelete={onDelete} />)}
    </div>
  </>
);
